import React, { useEffect } from "react";
import "../css/publications.css";
import AOS from "aos";
import "aos/dist/aos.css";
import about2 from '../../assets/img/parabsir-img/media6.jpeg';
import about3 from '../../assets/img/parabsir-img/media7.jpeg';
import about4 from '../../assets/img/parabsir-img/media8.jpeg';


import about5 from '../../assets/img/parabsir-img/media9.jpeg';
import about6 from '../../assets/img/parabsir-img/media10.jpeg';
import about7 from '../../assets/img/parabsir-img/media18.jpeg';

const Publications = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
    });
  }, []);
  return (
    <div>
      <section className="about-hero" data-aos="fade-up">
        <div className="hero-bg"></div>
        <div className="hero-content text-center text-white">
          <div className="container">
            <h1 className="fw-bold text-white">Media</h1>
            <p className="mt-3">
              Insights, legal analysis, and publications reflecting our
              expertise
            </p>
          </div>
        </div>
      </section>
      <section className="articles-wrapper" data-aos="fade-up" data-aos-delay="200">
  <div className="container">

    <h2 className="articles-heading">Articles & Publications</h2>

    <div className="row g-4">
      {/* Article Card */}
      <div className="col-md-6 col-lg-4">
        <div className="article-card">
          <div className="article-img">
            <img  src={about2}  alt="Law Image 1"  className="img-fluid hover-effect"/>
          </div>

          {/* <div className="article-meta">
            <span className="article-date">December 23, 2025</span>
          </div> */}

          <h5 className="article-title mt-3">
           Strengthening Property Registration and Housing Systems
          </h5>
        </div>
      </div>

      {/* Article Card */}
      <div className="col-md-6 col-lg-4">
        <div className="article-card">
          <div className="article-img">
           <img  src={about3}  alt="Law Image 1"  className="img-fluid hover-effect"/>
          </div>

          {/* <div className="article-meta">
            <span className="article-date">December 23, 2025</span>
          </div> */}

          <h5 className="article-title mt-3">
            Digital Transformation in Judicial Processes
          </h5>
        </div>
      </div>

      {/* Article Card */}
      <div className="col-md-6 col-lg-4">
        <div className="article-card">
          <div className="article-img">
             <img  src={about4}  alt="Law Image 1"  className="img-fluid hover-effect"/>
          </div>

          {/* <div className="article-meta">
          
            <span className="article-date">December 19, 2025</span>
          </div> */}

          <h5 className="article-title mt-3">
            Evolving Regulations in Cooperative Housing Societies
          </h5>
        </div>
      </div>

    </div>

    <div className="row g-4 mt-3">
      {/* Article Card */}
      <div className="col-md-6 col-lg-4">
        <div className="article-card">
          <div className="article-img">
            <img  src={about5}  alt="Law Image 1"  className="img-fluid hover-effect"/>
          </div>

          {/* <div className="article-meta">
            <span className="article-date">December 23, 2025</span>
          </div> */}

          <h5 className="article-title mt-3">
           Housing Societies Face Ongoing Challenges with Unregulated Builders </h5>
        </div>
      </div>

      {/* Article Card */}
      <div className="col-md-6 col-lg-4">
        <div className="article-card">
          <div className="article-img">
           <img  src={about6}  alt="Law Image 1"  className="img-fluid hover-effect"/>
          </div>

          {/* <div className="article-meta">
            <span className="article-date">December 23, 2025</span>
          </div> */}

          <h5 className="article-title mt-3">
            Streamlining Deemed Conveyance Through Online Systems
          </h5>
        </div>
      </div>

      {/* Article Card */}
      <div className="col-md-6 col-lg-4">
        <div className="article-card">
          <div className="article-img">
             <img  src={about7}  alt="Law Image 1"  className="img-fluid hover-effect "/>
          </div>

          {/* <div className="article-meta">
          
            <span className="article-date">December 19, 2025</span>
          </div> */}

          <h5 className="article-title mt-3">
           Addressing Corruption Concerns in Housing Redevelopment
          </h5>
        </div>
      </div>

    </div>
  </div>
</section>
   {/* <section className="practice-advice-section" data-aos="fade-up" data-aos-delay="200">
      <div className="container text-center">
        <h2 className="practice-title">Practice Advice</h2>
        <p className="practice-subtitle">
          Problems trying to resolve the conflict between <br />
          the two major realms of Classical physics: Newtonian mechanics
        </p>

        <div className="row justify-content-center mt-5">
          
          <div className="col-md-6 col-lg-3 mb-4">
            <div className="practice-card">
              <h5>Frauds or Mislead</h5>
              <p>
                Newton thought that light was made up of particles, but then it
                was discovered
              </p>
              <img src={about2} alt="Law Image 1" className="img-fluid hover-effect" />
            </div>
          </div>

          <div className="col-md-6 col-lg-3 mb-4">
            <div className="practice-card">
              <h5>Bailes & Warrants</h5>
              <p>
                “Quantum mechanics” is the description of the behaviour of matter
              </p>
              <img src={about2} alt="Law Image 1" className="img-fluid hover-effect" />
            </div>
          </div>

          <div className="col-md-6 col-lg-3 mb-4">
            <div className="practice-card">
              <h5>Federal Drug Crimes</h5>
              <p>
                They describe a universe consisting of bodies  moving moving
              </p>
              <img src={about2}  alt="Law Image 1" className="img-fluid hover-effect"/>
            </div>
          </div>

          <div className="col-md-6 col-lg-3 mb-4">
            <div className="practice-card">
              <h5>Traffic Related Crimes</h5>
              <p>
                They finally obtained a consistent description of the behaviour
              </p>
               <img src={about2} alt="Law Image 1" className="img-fluid hover-effect" />
            </div>
          </div>
        </div>
      </div>
    </section> */}

    </div>
  );
};

export default Publications;
